









































import Vue from 'vue'
import
  ModalSelectAdditionalOption
from '@/common/components/additionalOptions/ModalSelectAdditionalOption.vue'
import { ProductState } from '@/product/types'
import { AdditionalOption } from '@/common/types'

export default Vue.extend({
  components: {
    ModalSelectAdditionalOption
  },
  props: {
    options: {
      type: Array as () => AdditionalOption[],
      default: () => []
    },
    selectedAdditionalOptionIds: {
      type: Array as () => string[],
      default: () => []
    }
  },
  data(): {
    showSelectAdditionalOptionModal: boolean
  } {
    return {
      showSelectAdditionalOptionModal: false
    }
  },
  computed: {
    storeState(): ProductState {
      return this.$store.state
    },
    quantity(): number {
      return this.storeState.estimate.quantity
    },
    selectedAdditionalOptions(): AdditionalOption[] {
      return this.options.filter(item => this.selectedAdditionalOptionIds.includes(item.id))
    }
  },
  methods: {
    toggleShowSelectAdditionalOptionModal(): boolean {
      return this.showSelectAdditionalOptionModal = !this.showSelectAdditionalOptionModal
    },
    onUpdateAdditionalOptions(ids: string[]) {
      this.toggleShowSelectAdditionalOptionModal()
      this.$emit('update', ids)
    }
  }
})
